import { useMissionStore} from "@/stores/missionStore";
import { useReadingStore } from '@/stores/readingStore';

export class ConditionsReferentialBuilder {
  constructor(conditionsDTO) {
    this.conditionsDTO = conditionsDTO;
  }
  buildCategorySourceIds() {
    return (Object.values(this.conditionsDTO.configuration?.catalog?.category || []) || {}).map(
      (attachment) => attachment.id
    )
  }

  buildProductSourceIds(dnProductIndicators) {
    return (
      Object.values(this.conditionsDTO.configuration?.catalog?.product || []).filter((product) => {
        if (dnProductIndicators && dnProductIndicators.length > 0) {
          return dnProductIndicators.includes(product?.id?.toString())
        } else return true
      }) || {}
    ).map((attachment) => attachment.id)
  }

  buildPictureSourceIds() {
    return Object.entries(useReadingStore().picture)
      .filter(
        ([key, value]) => this.conditionsDTO.readingId && !value.to_remove && value.reading === this.conditionsDTO.readingId
      )
      .map(([key, value]) => key)
  }

  buildElementSourceIds() {
    return Object.entries(useReadingStore().element)
      .filter(
        ([key, value]) => this.conditionsDTO.readingId && !value.to_remove && value.reading === this.conditionsDTO.readingId
      )
      .map(([key, value]) => key)
  }
  buildAttachmentReferential() {
    const dnProductIndicators = useMissionStore()?.pointsOfSale[this.conditionsDTO.context?.pos?.id]?.productIndicators?.dn
    const categorySourceIds = this.buildCategorySourceIds()
    const productSourceIds = this.buildProductSourceIds(dnProductIndicators)
    const pictureSourceIds = this.buildPictureSourceIds()
    const elementSourceIds = this.buildElementSourceIds()
    this.conditionsDTO.attachmentListToParseForConditions = {
      by_category: {
        key: 'category',
        minimumRequired: 0,
        attachmentIds: categorySourceIds
      },
      by_product: {
        key: 'product',
        minimumRequired: 0,
        attachmentIds: productSourceIds
      },
      by_picture: {
        key: 'picture',
        minimumRequired: this.conditionsDTO.configuration?.settings?.nb_required_picture || 0,
        attachmentIds: pictureSourceIds
      },
      by_element: {
        key: 'element',
        minimumRequired: 0,
        attachmentIds: elementSourceIds
      }
    }
  }
}